import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../../app.component";

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {

  element: any;
  displayedColumns: string[] = ['sno', 'subject', 'date', 'file', 'url'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private landingService: LandingServiceService) {
  }

  announcements: any = [];
  baseBackUrl = myGlobals.baseUrl;

  ngOnInit(): void {
    this.landingService.getAllAnnouncements().subscribe(response => this.setAnnouncements(response));
  }

  setAnnouncements(data) {
    this.dataSource = new MatTableDataSource(data['Announcements']);
    this.dataSource.paginator =this.paginator;
    this.dataSource.sort = this.sort;
    this.announcements = data['Announcements'];
  }

  routeByUrl(data){
    window.open(data);
  }

  openAnnouncementLink(data){
    window.open(this.baseBackUrl+'/downloadAnnouncementHomepage?id='+window.btoa(data), '_blank').focus();
  }
}
